import { useEffect, useState } from "react";
import { Link2, RefreshCw, Save, Search } from "lucide-react";
import { api } from "../api";

export const ClassificationAdminActions = ({ detail, onRefresh }) => {
  const policy = detail.policy;
  const classification = detail.classification;
  const isBase = policy.record_role === "BASE_POLICY";
  const isMovement = policy.record_role === "DEPENDENT_MOVEMENT";
  const [overrideClass, setOverrideClass] = useState("Yeni İş");
  const [overrideReason, setOverrideReason] = useState("");
  const [linkSearch, setLinkSearch] = useState("");
  const [linkReason, setLinkReason] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [selectedBase, setSelectedBase] = useState("");
  const [busy, setBusy] = useState("");
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  useEffect(() => {
    setOverrideClass(classification?.business_classification === "Yenileme" ? "Yenileme" : "Yeni İş");
    setOverrideReason(""); setLinkReason(""); setCandidates([]); setSelectedBase("");
    setFeedback({ type: "", message: "" });
  }, [policy.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const execute = async (name, request, success) => {
    setBusy(name); setFeedback({ type: "", message: "" });
    try {
      await request();
      await onRefresh();
      setFeedback({ type: "success", message: success });
      setOverrideReason(""); setLinkReason(""); setCandidates([]); setSelectedBase("");
    } catch (error) {
      setFeedback({ type: "error", message: error.response?.data?.detail || "İşlem tamamlanamadı." });
    } finally { setBusy(""); }
  };

  const rematch = () => execute(
    "rematch", () => api.post(`/policies/${policy.id}/classification-rematch`),
    "Bu poliçe ailesi için eşleştirme ve sınıflandırma yeniden çalıştırıldı."
  );
  const saveOverride = () => {
    if (overrideReason.trim().length < 3) return setFeedback({ type: "error", message: "Değişiklik nedeni en az 3 karakter olmalıdır." });
    return execute("override", () => api.post(`/policies/${policy.id}/classification-override`, {
      classification: overrideClass, reason: overrideReason,
    }), "Manuel sınıflandırma kaydedildi.");
  };
  const resetOverride = () => {
    if (overrideReason.trim().length < 3) return setFeedback({ type: "error", message: "Otomatik sonuca dönüş nedeni en az 3 karakter olmalıdır." });
    return execute("reset-override", () => api.post(`/policies/${policy.id}/classification-override/reset`, {
      reason: overrideReason,
    }), "Otomatik sınıflandırmaya dönüldü.");
  };
  const searchCandidates = async () => {
    if (linkSearch.trim().length < 2) return setFeedback({ type: "error", message: "Ana poliçe araması en az 2 karakter olmalıdır." });
    setBusy("search");
    try {
      const response = await api.get(`/policies/${policy.id}/base-policy-candidates`, { params: { search: linkSearch } });
      setCandidates(response.data.items); setFeedback({ type: "", message: "" });
    } catch (error) {
      setFeedback({ type: "error", message: error.response?.data?.detail || "Ana poliçe adayları alınamadı." });
    } finally { setBusy(""); }
  };
  const saveLink = () => {
    if (!selectedBase) return setFeedback({ type: "error", message: "Bir ana poliçe seçin." });
    if (linkReason.trim().length < 3) return setFeedback({ type: "error", message: "Bağlantı nedeni en az 3 karakter olmalıdır." });
    return execute("link", () => api.post(`/policies/${policy.id}/base-policy-link`, {
      base_policy_id: selectedBase, reason: linkReason,
    }), "Hareket ana poliçeye bağlandı ve effective sınıfı devraldı.");
  };
  const resetLink = () => {
    if (linkReason.trim().length < 3) return setFeedback({ type: "error", message: "Sıfırlama nedeni en az 3 karakter olmalıdır." });
    return execute("reset-link", () => api.post(`/policies/${policy.id}/base-policy-link/reset`, {
      reason: linkReason,
    }), "Manuel ana poliçe bağlantısı kaldırıldı; otomatik eşleştirme yeniden çalıştı.");
  };

  return <div className="classification-admin-actions" data-testid="classification-admin-actions">
    <div className="classification-admin-toolbar">
      <strong>Admin düzeltmeleri</strong>
      <button data-testid="classification-rematch-button" className="outline-button" disabled={!!busy} onClick={rematch}>
        <RefreshCw size={13}/> {busy === "rematch" ? "Çalışıyor..." : "Eşleştirmeyi Tekrar Çalıştır"}
      </button>
    </div>

    <div className="classification-override-editor" data-testid="classification-override-editor">
      <div className="classification-override-title"><strong>{isMovement ? "Hareket için manuel reporting sınıfı" : "Manuel sınıflandırma"}</strong><span>Otomatik sonuç: <b data-testid="classification-automatic-value">{classification?.automatic_classification || "Hazırlanmadı"}</b></span></div>
      <label>Effective sonuç<select data-testid="classification-override-select" value={overrideClass} onChange={(event) => setOverrideClass(event.target.value)}><option value="Yeni İş">Yeni İş</option><option value="Yenileme">Yenileme</option></select></label>
      <label>Değişiklik nedeni<textarea data-testid="classification-override-reason" rows={2} value={overrideReason} onChange={(event) => setOverrideReason(event.target.value)} placeholder="Zorunlu audit notu"/></label>
      <div className="classification-override-actions"><button data-testid="classification-override-save" className="primary-button" disabled={!!busy} onClick={saveOverride}><Save size={13}/> Manuel sonucu kaydet</button>{classification?.manual_override_active && <button data-testid="classification-override-reset" className="outline-button" disabled={!!busy} onClick={resetOverride}>Otomatik Sınıflandırmaya Dön</button>}</div>
    </div>

    {isMovement && <div className="base-policy-link-editor" data-testid="base-policy-link-editor">
      <div className="classification-override-title"><strong>Ana Poliçeye Bağla</strong><span data-testid="current-base-policy-link">{detail.base_link ? `Bağlı kayıt: ${detail.base_link.base_policy_id}` : "Bağlantı yok; Data Quality uyarısı reporting sınıfından bağımsızdır"}</span></div>
      <div className="base-policy-search"><input data-testid="base-policy-search-input" value={linkSearch} onChange={(event) => setLinkSearch(event.target.value)} placeholder="Poliçe no veya müşteri ara"/><button data-testid="base-policy-search-button" className="outline-button" disabled={!!busy} onClick={searchCandidates}><Search size={13}/> Ara</button></div>
      {candidates.length > 0 && <div className="base-policy-candidates" data-testid="base-policy-candidates">{candidates.map((candidate) => <button key={candidate.id} data-testid={`base-policy-candidate-${candidate.id}`} className={selectedBase === candidate.id ? "selected" : ""} onClick={() => setSelectedBase(candidate.id)}><strong>{candidate.policy_number} · T{candidate.renewal_number || 0}</strong><span>{candidate.canonical_customer_name || candidate.policyholder_name || candidate.customer_name || "—"}</span><em>{candidate.issue_date || "—"} · {candidate.business_classification || "Hazırlanmadı"}</em></button>)}</div>}
      <label>Bağlantı nedeni<textarea data-testid="base-policy-link-reason" rows={2} value={linkReason} onChange={(event) => setLinkReason(event.target.value)} placeholder="Zorunlu audit notu"/></label>
      <div className="classification-override-actions"><button data-testid="base-policy-link-save" className="primary-button" disabled={!!busy || !selectedBase} onClick={saveLink}><Link2 size={13}/> Seçilen Ana Poliçeye Bağla</button>{detail.base_link && <button data-testid="base-policy-link-reset" className="outline-button" disabled={!!busy} onClick={resetLink}>Manuel Bağlantıyı Kaldır</button>}</div>
    </div>}
    {feedback.message && <div data-testid="classification-admin-feedback" className={`override-feedback ${feedback.type}`}>{feedback.message}</div>}
  </div>;
};